import { SidesheetState } from './types';

export const initialState: SidesheetState = {
  opened: null,
  slots: {},
  current: null,
};
